import React, { useState } from 'react';
import API from '@lib/API';

function SearchArticle({ lang }) {
  const [searchTerm, setSearchTerm] = useState('');
  const AuthAPI = new API();

  const onChange = e => {
    const value = e.target.value;

    setSearchTerm(value);
  };

  const onSearchFocus = () => {
    AuthAPI.sendAmplitudeEvent('Click Blog Search Bar');
  };

  const onSearchSubmit = () => {
    if (searchTerm) {
      AuthAPI.sendAmplitudeEvent('Blog Search', {
        'Search Query': searchTerm,
        Language: lang,
      });
    }
  };

  return (
    <div className="rounded-full shadow-md max-w-lg mx-auto bg-gray-100">
      <form
        method="get"
        className="searchform_theme flex items-center justify-between"
        action="/blog/"
        onSubmit={onSearchSubmit}
      >
        <input
          type="text"
          placeholder="Search Articles, Tips..."
          value={searchTerm}
          autoComplete="off"
          onFocus={onSearchFocus}
          onChange={onChange}
          name="s"
          className="search_btn rounded-full outline-none p-4 px-6 w-full bg-transparent"
        />
        <button type="submit" className="button p-4">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="#9c9c9c"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </button>
      </form>
    </div>
  );
}

export default SearchArticle;
